<div class="stat-tile">
	<div class="stat-tile__value" [ngClass]="Variant">{{ Value }}</div>
	<div class="stat-tile__label">{{ Label }}</div>
	<div class="stat-tile__delta" *ngIf="Delta" [ngClass]="DeltaKind">{{ Delta }}</div>
	<svg *ngIf="HasSpark" class="stat-tile__spark" [class.up]="SparkUp" viewBox="0 0 100 24" preserveAspectRatio="none" aria-hidden="true">
		<polyline [attr.points]="SparkPoints"></polyline>
	</svg>
</div>
